export const AppTheme = {
  white: "#FFFFFF",
  sunglow: "#F7CA41",
  darkMidnigthBlue: "#003460",
  lavanderMist: "#D9EEFF",
  barleyWhite: "#FFF3CE",
  darkBurgundy: "#770C0E",
  greyGoose: "#CFCFCF",
  transparent: "transparent",
  dune: "#343434",
  blackCow: "#464646",
  darkJungleGreen: "#232323",
  dawn: "#a4a4a4",
  wedgeWood: "#4E7F9E",
  grandis: "#FFD782",
  roseMadder: "#941717",
  butterScotch: "#FDB841",
  artiClickRed: "#FF0000",
  blueIvy: "#2788C9",
  carbonGrey: "#5A5A5A",
  purpleIris: "#6B0E93",
  hawaiianTan: "#945E14",
  yellowOchre: "#D29000",
  darkSage: "#588157",
  lawnGreen: "#38b000",
  aquaHaze: "#F3F3F3",
  oasis: "#FFF1C7",
  osloGrey: "#8F8F8F",
  laSalleGreen: "#0A8525",
  monSoon: "#898989",
  fireEngineRed: "#CE2222",
  oldGold: "#DEAA38",
  butterflyBlue: "#22B0ED",
  paleSlate: "#C1BFBE",
  lemonGrass: "#999999",
  whiteSmoke: "#F5F5F5",
  brightSun: "#FBD332",
  darkMustard: "#AC8700",
  brightBlue: "#0866FF",
  porcelain: "#F2F2F2",
  greyCloud: "#B7B6B6",
  softPeach: "#EEE",
  muddyBrown: "#836902",
  black: "#000000",
  oakBrown: "#7F6A20",
};
